


























































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Validator, FieldError } from 'vee-validate';

import ModalMobile from '@/shared/components/ModalMobile/ModalMobile.vue';
import AddressComponent from '@/shared/components/Address/Address.vue';

import { ICheckoutCartOffer } from '@/interfaces/Checkout';

import Address from '@/classes/Address';

const CheckoutModule = namespace('App/Checkout');
const CustomerModule = namespace('App/Customer');
const BehaviorModule = namespace('App/Behavior');

@Component({
  components: {
    ModalMobile,
    Address: AddressComponent
  },
})
export default class DeliveryAddressMobile extends Vue {
  @CheckoutModule.State(state => state.checkout.cart.offer)
  private readonly offer: ICheckoutCartOffer;

  @CustomerModule.Getter('deliveryAddress')
  private readonly deliveryAddress: Address;

  @CustomerModule.Mutation('setDeliveryAddress')
  private setDeliveryAddress: Function;

  @BehaviorModule.Mutation('setDeliveryAddressValid')
  private setDeliveryAddressValid: Function;

  private validator = new Validator();

  private modalOpen: boolean = false;

  private get title(): string {
    return this.offer.address_text_title || '';
  }

  private get place(): string {
    const { street_name: streetName, street_number: streetNumber, complement } = this.deliveryAddress;

    let place = `${streetName}, ${streetNumber}`;

    if (complement) {
      place += `, ${complement}`;
    }

    return place;
  }

  private address = new Address({
    street_name: '',
    city: '',
    neighborhood: '',
    state: '',
    postal_code: '',
    ibge_code: '',
  });

  private async updateDeliveryAddress() {
    try {
      await this.validateAddress();
      this.setDeliveryAddress({
        ...this.address,
        is_default: false,
        is_billing: false,
        is_delivery: true,
      });

      this.setDeliveryAddressValid(true);

      this.closeModal();
    } catch (e) {
      this.setDeliveryAddressValid(false);

      console.error(e);
    }
  }

  private closeModal() {
    const $modal: any = this.$refs.modal;
    const $closeButton = $modal.$refs['close'];

    $closeButton && $closeButton.click();
  }

  private zipCodeNotFound(): void {
    this.address = {
      ...this.address,
      street_name: '',
      street_number: '',
      city: '',
      neighborhood: '',
      state: '',
      ibge_code: ''
    };
  }

  private resetAddress() {
    this.address = new Address({
      street_name: '',
      city: '',
      neighborhood: '',
      state: '',
      postal_code: '',
      ibge_code: '',
    });
  }

  private validateAddress() {
    return new Promise(async (resolve: any, reject) => {
      const result = await this.validator.validateAll({
        ...this.address,
      });

      result ? resolve() : reject();
    });
  }
}
